import { watchGetUserPlan } from 'store/global/auth/sagas/watchGetUserPlan';
import { watchUpdateThemeIdOfUser } from 'store/global/auth/sagas/watchUpdateThemeIdOfUser';
import { watchVerifyStorefrontPassword } from 'store/global/auth/sagas/watchVerifyStorefrontPassword';
import { watchVerifyUser } from './watchVerifyUser';

export const sagasAuth = [watchVerifyUser, watchVerifyStorefrontPassword, watchUpdateThemeIdOfUser, watchGetUserPlan];
